var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 7.41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.41 0L6 4.58 10.59 0 12 1.41l-6 6-6-6z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiA3LjQxIj4KPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNNy40MSw3Ljg0LDEyLDEyLjQybDQuNTktNC41OEwxOCw5LjI1bC02LDYtNi02WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYgLTcuODQpIi8+Cjwvc3ZnPg==";
export { SvgCaretArrowDown as ReactComponent };